export type {GetSelfQuery as GetSelf} from '../generated/attendee-types';
export {GetSelfQuery} from './queries';
